/**
 * Komponent renderujący dolny pasek tabeli.
 * Dane z kontekstu WiseTable (useWiseTable).
 */

import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { Pagination } from 'components/controls';
import WiseSelect from 'components/wise/WiseSelect';

import { useWiseTable } from 'components/wise/WiseTable/context';

import styles from 'theme/components/wise/WiseTable/components/TableBottomBar/TableBottomBar.module.scss';

const TableBottomBar: FC = () => {
  const {
    tableData,
    queryParams,
    handlePageChange,
    handleLimitChange,
    config
  } = useWiseTable();

  const { limitOptions, isCondensed } = config;

  if (!tableData) {
    return null;
  }

  if (isCondensed) {
    return (
      <div className={styles.bottomBarWrapper}>
        <div className={styles.bottomBarCondensed}>
          <Pagination
            className={styles.pagination}
            pagesCount={tableData.total_pages}
            page={tableData.page}
            onChange={(page) => {
              if (page !== tableData.page) {
                handlePageChange(page);
              }
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.bottomBarWrapper}>
      <div className={styles.bottomBar}>
        <div className={styles.bottomBarLeft}>
          <div className={styles.pageInfo}>
            <Trans>Strona</Trans> {tableData.page} z {tableData.total_pages} (
            {tableData.total_count} <Trans>rekordów</Trans>)
          </div>
        </div>

        <div className={styles.bottomBarCenter}>
          <Pagination
            className={styles.pagination}
            pagesCount={tableData.total_pages}
            page={tableData.page}
            onChange={(page) => {
              if (page !== tableData.page) {
                handlePageChange(page);
              }
            }}
          />
        </div>

        <div className={styles.bottomBarRight}>
          <Trans>Wierszy na stronie</Trans>
          <div className={styles.limitSelector}>
            <WiseSelect<{ limit: number }>
              styleGroup="portal"
              placeholder=""
              options={limitOptions.map((limit) => ({
                value: limit,
                label: `${limit}`,
                item: { limit }
              }))}
              value={queryParams.limit}
              onChange={(item) => {
                if (item !== null) {
                  handleLimitChange(item.limit);
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableBottomBar;
